import { StyleSheet } from 'react-native'

export default StyleSheet.create({
  buttonContainer: theme => ({
    paddingHorizontal: 16,
    paddingTop: 15,
    position: 'absolute',
    zIndex: 1000,
    bottom: 110,
    width: '100%',
    backgroundColor: theme.colors.backgroundColorSeven
  }),
  firstCardLoadingStyle: {
    marginLeft: 16,
  },
  container: {
    flex: 1
  }
})
